import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Delivery from '@/models/delivery.js'

export const useDeliveryStore =  defineStore('deliveryStore', () => {
  let syncableModel = useSyncableModel(useApiResource('deliveries'), {
    className: Delivery.modelName.name,
    paramKey: Delivery.modelName.paramKey
  })

  async function createDelivery(delivery) {
    try {
      const data = await syncableModel.resource.post("/", { delivery });
      if (data.status === "ok") syncableModel.collection.value.push(delivery);
      return data;
    }
    catch (error) {
      console.error('Failed to create delivery', error);
      throw error;
    }
  }

  function confirmDelivery(uuid) {
    console.log(uuid);
  }

  async function confirmPayment(delivery) {
    try {
      const data = await syncableModel.resource.post(`${delivery.deliveryUuid}/confirm_payment`, { delivery });
      if (data.status === "ok") {
        delivery = syncableModel.collection.value.find((item) => item.uuid == delivery.deliveryUuid)
        delivery.paymentStatus = "Paid"
      }
      return data;
    }
    catch (error) {
      console.error('Failed to create delivery', error);
      throw error;
    }
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  function findByUuid(uuid) {
    return syncableModel.all().find((item) => item.uuid == uuid)
  }

  return {
    ...syncableModel,
    createDelivery,
    confirmDelivery,
    confirmPayment,
    findByUuid,
    $reset
  }

}, {
  persist: true
})
